export default __webpack_public_path__ + "static/media/04AW2APR66.151eff16.jpg";